const planOptions = [
  { value: null, label: "Null" },
  { value: 1,    label: 'Free' },
  { value: 2,    label: 'Bronze' },
  { value: 3,    label: 'Silver' },
  { value: 4,    label: 'Gold' },
];

export default planOptions;
